import { app } from '../../env'
import { isAppleRetailMerchantId } from './appleRetail'

export const isAppleRetailOrder = (merchantId: number | null | undefined): boolean => {
  return isAppleRetailMerchantId(merchantId, app.APPLE_RETAIL_MIDS)
}
